import React, { useEffect, useState } from 'react';
import './style.css';
import bgImage from '../../assests/Home/Hero.png'; // ✅ Correct path
import { useNavigate } from "react-router-dom";

const services = [
    "Construction Service",
    "Demolition Service",
    "AC Service",
    "Electrical Service",
    "Security System"
];

const reviews = [
  {
    text: "They completed my full home renovation ahead of schedule — including demolition, waterproofing, and tiling. Impressive work!",
    stars: 5
  },
  {
    text: "Got concrete work and structural strengthening done for my building. Solid team and flawless execution.",
    stars: 5
  },
  {
    text: "AC installation, electrical wiring, and CCTV setup all done professionally in one go. Super convenient!",
    stars: 5
  }
];


export default function HeroSection() {
      const navigate = useNavigate();
    const [currentService, setCurrentService] = useState(0);
    const [currentReview, setCurrentReview] = useState(0);

  const handleCTA = () => {
    navigate("/about-us"); // This will navigate to About Us and include the hash
  };
    // Rotating services animation
    useEffect(() => {
        const timer = setTimeout(() => {
            setCurrentService((prev) => (prev + 1) % services.length);
        }, 4200);
        return () => clearTimeout(timer);
    }, [currentService]);

    // Handle next review
    const handleNextReview = () => {
        setCurrentReview((prev) => (prev + 1) % reviews.length);
    };

    return (
        <section
            className="hero"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <div className="overlay"></div>

            <div className="hero-content">
                <div className="hero-left">
                    <h1>Your One-Stop Solution for Construction, Electrical & CCTV.</h1>
                    <p>Serving clients across Singapore with reliable, professional solutions.</p>
                    <p>We specialize in efficient, end-to-end project delivery.</p>
                    <p>Experience, quality, and integrity in every job.</p>
                    <div onClick={handleCTA} className="cta-div">Know More About Us</div>
                    
                    <div className="fea-ani">
                        <h2 className="providing-title">WE ARE PROVIDING</h2>
                        <div className="service-loop" aria-live="polite">
                            <span
                                key={services[currentService]}
                                className="fade-text"
                            >
                                {services[currentService]}
                            </span>
                        </div>
                    </div>


                </div>
            </div>

            {/* Bottom-Right Review Box */}
            <div className="review-box">
                <p className="review-text">"{reviews[currentReview].text}"</p>
                <div className="stars">
                    {"⭐".repeat(reviews[currentReview].stars)}
                </div>
                <div className="next-review-btn" onClick={handleNextReview}>
                    ➜
                </div>
            </div>
        </section>
    );
}
